import { useEffect, useRef } from "react";
import { supabase } from "@/lib/supabase";

export interface TicketChange {
  id: string;
  status: string;
  checked_in_at: string | null;
}

/**
 * Abonneer op live ticket-wijzigingen (check-ins) van álle apparaten via Supabase Realtime.
 * Valt stil terug op de gewone polling als realtime niet doorkomt.
 */
export function useTicketsRealtime(onChange: (row: TicketChange) => void) {
  const cb = useRef(onChange);
  cb.current = onChange;
  useEffect(() => {
    const ch = supabase
      .channel("tickets-door")
      .on(
        "postgres_changes",
        { event: "UPDATE", schema: "public", table: "tickets" },
        (payload) => {
          const n = payload.new as TicketChange;
          if (n && n.id) cb.current(n);
        },
      )
      .subscribe();
    return () => { void supabase.removeChannel(ch); };
  }, []);
}
